window.dayjs = require('dayjs');
require('dayjs/locale/es');
require('dayjs/locale/en');

var customParseFormat = require('dayjs/plugin/customParseFormat');
var utc = require('dayjs/plugin/utc');
var timezone = require('dayjs/plugin/timezone');
var isBetween = require('dayjs/plugin/isBetween');
var isSameOrAfter = require('dayjs/plugin/isSameOrAfter');
var isSameOrBefore = require('dayjs/plugin/isSameOrBefore');
var duration = require('dayjs/plugin/duration');
var relativeTime = require('dayjs/plugin/relativeTime');
var localizedFormat = require('dayjs/plugin/localizedFormat');
var weekOfYear = require('dayjs/plugin/weekOfYear');
var isoWeek = require('dayjs/plugin/isoWeek');
var minMax = require('dayjs/plugin/minMax');
var dayOfYear = require('dayjs/plugin/dayOfYear');
var updateLocale = require('dayjs/plugin/updateLocale');
var weekday = require('dayjs/plugin/weekday');

window.dayjs.extend(customParseFormat);
window.dayjs.extend(utc);
window.dayjs.extend(timezone);
window.dayjs.extend(isBetween);
window.dayjs.extend(isSameOrAfter);
window.dayjs.extend(isSameOrBefore);
window.dayjs.extend(duration);
window.dayjs.extend(relativeTime);
window.dayjs.extend(localizedFormat);
window.dayjs.extend(weekOfYear);
window.dayjs.extend(isoWeek);
window.dayjs.extend(minMax);
window.dayjs.extend(dayOfYear);
window.dayjs.extend(updateLocale);
window.dayjs.extend(weekday);

window.dayjs.parseZone = function(date) {
    // Basic polyfill for moment.parseZone
    // Keeps the local timezone of the input string if possible, or falls back to local.
    // dayjs parses differently, but this is a reasonable approximation for Vue filters.
    return window.dayjs(date);
};

// Set global locale correctly ensuring fallback to available 'es' or 'en' locales
window.dayjs.locale(window.__pt.culture.cultureCode);